import {
  PROJECT_LIST,
  PROJECT_LIST_ERROR,
  PROJECT_LIST_SUCCESS,
  TIMESHEET_USER,
  TIMESHEET_USER_ERROR,
  TIMESHEET_USER_SUCCESS,
  SCREEN_VERIFIED,
  SCREEN_VERIFIED_SUCCESS,
  SCREEN_VERIFIED_ERROR,
  ACTIVITY_SUMMARY,
  ACTIVITY_SUMMARY_SUCCESS,
  ACTIVITY_SUMMARY_ERROR,
  EXCLUDE_SCREEN,
  EXCLUDE_SCREEN_SUCCESS,
  EXCLUDE_SCREEN_ERROR,
  EXCLUDE_SCREEN_LOGS,
  EXCLUDE_SCREEN_LOGS_SUCCESS,
  EXCLUDE_SCREEN_LOGS_ERROR,
  TEAM_GET_SCREEN_LOGS,
  TEAM_GET_SCREEN_LOGS_SUCCESS,
  TEAM_GET_SCREEN_LOGS_ERROR,
  FILTERED_SCREEN_IMAGES,
  GET_PROJECT_SUMMARY_REPORT_SCREEN,
  GET_PROJECT_SUMMARY_REPORT_SCREEN_SUCCESS,
  GET_PROJECT_SUMMARY_REPORT_SCREEN_ERROR,
  GET_PROJECT_SUMMARY_WORK_REPORTS,
  GET_PROJECT_SUMMARY_WORK_REPORTS_SUCCESS,
  GET_PROJECT_SUMMARY_WORK_REPORTS_ERROR,
} from "./actionTypes"

const initialState = {
  timeSheetReportSuccessList: null,
  timeSheetReportError: null,
  activitysummarySuccessList: null,
  activitysummaryError: null,
  projectListSuccess: null,
  projectListError: null,
  excludescreenSuccessList: null,
  excludescreenError: null,
  excludescreenlogsSuccessList: null,
  excludescreenlogsError: null,
  teamscreenlogsSuccessList: null,
  teamscreenlogsError: null,
  filteredScreenImages: [],
}

const timesheet = (state = initialState, action) => {
  switch (action.type) {
    case TIMESHEET_USER:
      state = {
        ...state,
        timeSheetReportSuccessList: null,
        timeSheetReportError: null,
      }
      break

    case TIMESHEET_USER_SUCCESS:
      // Use map to modify the date property within the projectTimeSheet array
      const modifiedPayload = action?.payload?.map(projecthours => {
        const updatedProjectTimeSheet = projecthours?.projectTimeSheet.map(
          timesheetdate => ({
            ...timesheetdate, // Copy the existing properties
            date: projecthours?.timeSummaryDate, // Update the date property
          })
        )
        return {
          ...projecthours, // Copy the existing properties
          projectTimeSheet: updatedProjectTimeSheet, // Update the projectTimeSheet property
        }
      })
      state = {
        ...state,
        timeSheetReportSuccessList: modifiedPayload,
        timeSheetReportError: null,
      }
      break

    case TIMESHEET_USER_ERROR:
      state = { ...state, timeSheetReportError: action.payload }
      break

    case PROJECT_LIST:
      state = {
        ...state,
        projectListSuccess: null,
        projectListError: null,
      }
      break

    case PROJECT_LIST_SUCCESS:
      state = {
        ...state,
        projectListSuccess: action.payload,
        projectListError: null,
      }
      break

    case PROJECT_LIST_ERROR:
      state = { ...state, projectListError: action.payload }
      break

    case SCREEN_VERIFIED:
      state = {
        ...state,
        screenVerifiedSuccessList: null,
        screenVerifiedError: null,
      }
      break

    case SCREEN_VERIFIED_SUCCESS:
      state = {
        ...state,
        screenVerifiedSuccessList: action.payload,
        screenVerifiedError: null,
      }
      break

    case SCREEN_VERIFIED_ERROR:
      state = { ...state, screenVerifiedError: action.payload }
      break
    // Activity summary
    case ACTIVITY_SUMMARY:
      state = {
        ...state,
        activitysummarySuccessList: null,
        activitysummaryError: null,
      }
      break

    case ACTIVITY_SUMMARY_SUCCESS:
      state = {
        ...state,
        activitysummarySuccessList: action.payload,
        activitysummaryError: null,
      }
      break

    case ACTIVITY_SUMMARY_ERROR:
      state = { ...state, activitysummaryError: action.payload }
      break

    // exclude screen
    case EXCLUDE_SCREEN:
      state = {
        ...state,
        excludescreenSuccessList: null,
        excludescreenError: null,
      }
      break

    case EXCLUDE_SCREEN_SUCCESS:
      state = {
        ...state,
        excludescreenSuccessList: action.payload,
        excludescreenError: null,
      }
      break

    case EXCLUDE_SCREEN_ERROR:
      state = { ...state, excludescreenError: action.payload }
      break

    // exclude screen logs
    case EXCLUDE_SCREEN_LOGS:
      state = {
        ...state,
        excludescreenlogsSuccessList: null,
        excludescreenlogsError: null,
      }
      break

    case EXCLUDE_SCREEN_LOGS_SUCCESS:
      state = {
        ...state,
        excludescreenlogsSuccessList: action.payload,
        excludescreenlogsError: null,
      }
      break

    case EXCLUDE_SCREEN_LOGS_ERROR:
      state = { ...state, excludescreenlogsError: action.payload }
      break

    // ########## TEAM START SCREEN LOGS #########################################################
    // exclude screen logs
    case TEAM_GET_SCREEN_LOGS:
      state = {
        ...state,
        teamscreenlogsSuccessList: null,
        teamscreenlogsError: null,
      }
      break

    case TEAM_GET_SCREEN_LOGS_SUCCESS:
      state = {
        ...state,
        teamscreenlogsSuccessList: action.payload,
        teamscreenlogsError: null,
      }
      break

    case TEAM_GET_SCREEN_LOGS_ERROR:
      state = { ...state, teamscreenlogsError: action.payload }
      break
    case FILTERED_SCREEN_IMAGES:
      state = { ...state, filteredScreenImages: action.payload }
      break

    // #################### TEAM END SCREEN LOGS ###########################################
    // hoursreport  screen logs
    case GET_PROJECT_SUMMARY_REPORT_SCREEN:
      state = {
        ...state,
        getprojectsummaryreportscreens: null,
        getprojectsummaryreportscreensError: null,
      }
      break

    case GET_PROJECT_SUMMARY_REPORT_SCREEN_SUCCESS:
      state = {
        ...state,
        getprojectsummaryreportscreens: action.payload,
        getprojectsummaryreportscreensError: null,
      }
      break

    case GET_PROJECT_SUMMARY_REPORT_SCREEN_ERROR:
      state = { ...state, getprojectsummaryreportscreensError: action.payload }
      break

    // hoursreport  report logs
    case GET_PROJECT_SUMMARY_WORK_REPORTS:
      state = {
        ...state,
        getprojectsummaryreports: null,
        getprojectsummaryreportsError: null,
      }
      break

    case GET_PROJECT_SUMMARY_WORK_REPORTS_SUCCESS:
      state = {
        ...state,
        getprojectsummaryreports: action.payload,
        getprojectsummaryreportsError: null,
      }
      break

    case GET_PROJECT_SUMMARY_WORK_REPORTS_ERROR:
      state = { ...state, getprojectsummaryreportsError: action.payload }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default timesheet
